import { render, staticRenderFns } from "./SensorInfo.vue?vue&type=template&id=1020d258&scoped=true&"
import script from "./SensorInfo.vue?vue&type=script&lang=js&"
export * from "./SensorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SensorInfo.vue?vue&type=style&index=0&id=1020d258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020d258",
  null
  
)

export default component.exports